import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { ActionAttachment } from 'src/app/commons/models/action-attachment.model';
import { PAGE_SIZE_OPTIONS } from 'src/app/helpers/table.helper';
import * as ActionAttachmentActions from 'src/app/store/actions/action-attachment.actions';
import { AppState } from 'src/app/store/reducers';
import * as ActionAttachmentSelectors from 'src/app/store/selectors/action-attachment.selectors';
import * as AuthSelectors from 'src/app/store/selectors/auth.selectors';

import { ActionAttachmentFilters } from '../../../commons/models/action-attachment.model';
import { ActionAttachmentsColumn } from '../action-attachment-list/action-attachment-list.component';


@Component({
  selector: 'app-action-attachment-selection',
  templateUrl: './action-attachment-selection.component.html',
  styleUrls: ['./action-attachment-selection.component.scss']
})
export class ActionAttachmentSelectionComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();

  actionAttachments: Observable<ActionAttachment[]>;
  filters: Observable<ActionAttachmentFilters>;

  @Input()
  defaultFilters: ActionAttachmentFilters = {
    search: "",
  }

  displayedColumns: ActionAttachmentsColumn[] = ["id", "name", "file", "actions"];

  pageSizeOptions = PAGE_SIZE_OPTIONS;

  total: Observable<number>;
  constructor(private store$: Store<AppState>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.actionAttachments = this.store$.pipe(select(ActionAttachmentSelectors.getActionAttachments), takeUntil(this.unsubscribe$), map(dtos => dtos ? dtos.map(dto => new ActionAttachment(dto)) : null));
    this.total = this.store$.pipe(select(ActionAttachmentSelectors.getTotalActionAttachments), takeUntil(this.unsubscribe$));
    this.filters = this.store$.pipe(select(ActionAttachmentSelectors.getFilters), takeUntil(this.unsubscribe$));
    if (data) {
      this.defaultFilters = data.defaultFilters;
    }
  }

  load() {
    this.store$.dispatch(ActionAttachmentActions.loadActionAttachments(
      { page: 1, perPage: this.pageSizeOptions[0], filters: this.defaultFilters }));
  }

  sortChange(sort: Sort) {
    this.store$.dispatch(ActionAttachmentActions.changeSort({ order: sort.active, direction: sort.direction }));
  }

  pageChange(pageEvent: PageEvent) {
    this.store$.dispatch(ActionAttachmentActions.changePage({ page: pageEvent.pageIndex + 1, size: pageEvent.pageSize }))
  }

  filtersChange(filters: ActionAttachmentFilters) {
    this.store$.dispatch(ActionAttachmentActions.changeFilters({ filters }));
  }

  ngOnInit() {
    this.load();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  selectActionAttachment(actionAttachment: ActionAttachment) {
    if (actionAttachment) {
      this.store$.dispatch(ActionAttachmentActions.actionAttachmentSelected({ actionAttachment: actionAttachment.toDTO() }));
    }
  }

  close() {
    this.store$.dispatch(ActionAttachmentActions.closeSelectionDialog())
  }
}
